/* eslint-disable no-dupe-keys */
/* eslint-disable jsx-a11y/scope */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import Content from "../../../layout/content/Content";
import { Card, Spinner, FormGroup } from "reactstrap";
import {
    Button,
    Block,
    Row,
    Col,
    Icon,
} from "../../../components/Component";
import Swal from "sweetalert2";
import Head from "../../../layout/head/Head";
import ES6Update from "./ES6Update";
import { DownloadTableExcel } from 'react-export-table-to-excel';
import OptionCDisable from "../../components/DynmicOption/OptionCDisable.";
import * as xlsx from "xlsx";

const ES6Edit = ({ ...props }) => {
    const [dataactive, setdataactive] = useState([]);
    const [Totall, setTotal] = useState([]);
    const [GTotal, setGTotal] = useState(0);
    const [Change, setchange] = useState(true);
    const [Gloading, setGloading] = useState(false);
    const [Totall2, setTotal2] = useState([]);
    const [userData, setuserData] = useState("");
    const month1 = ["Test", "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"]
    const [employmentId, setemloymentId] = useState(sessionStorage.getItem("employmentId"));
    const [Draft, setDraft] = useState(true);
    const today = new Date();
    const tableRef = useRef(null);
    const [loading, setloading] = useState(false);
    const [exportloading, setexportloading] = useState(false);
    const [formData, setFormData] = useState({
        EmploymentId: Number(props.employmentId),
        UserId: Number(localStorage.getItem("userId")),
        ParametersId: Number(props.parametersId),
        month: sessionStorage.getItem("CurrentMonth") === null ? (today.getMonth() === 0 ? 12 : today.getMonth()) : sessionStorage.getItem("CurrentMonth"),
        dummymonth: sessionStorage.getItem("CurrentMonth") === null ? month1[today.getMonth()] : month1[sessionStorage.getItem("CurrentMonth")],
        year: sessionStorage.getItem("CurrentYear") === null ? (today.getMonth() === 0 ? today.getFullYear() - 1 : today.getFullYear()) : sessionStorage.getItem("CurrentYear"),
        EmploymentRefId: sessionStorage.getItem("EmploymentRefId"),
    });
    const onInputChange = (month, year) => {
        setFormData({ ...formData, month: month, year: year });

    };

    const Total = async (empId) => {

        const sendData = {

            EmploymentId: Number(empId),
        }
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Data/GetES6Total1', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {

                    //console.log(data[0])
                    setTotal(data[0])
                })


    };

    const Total2 = async (empId) => {

        const sendData = {

            EmploymentId: Number(empId),
        }
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Data/GetES6Total2', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {

                    //console.log(data[0])
                    setTotal2(data[0])
                })


    };

    const getdata2 = async () => {

        const sendData = {

            EmploymentRefId: Number(formData.EmploymentRefId),
        }


        await fetch(process.env.REACT_APP_API_LINK + 'api/Main/Getparameters', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    //console.log(data)
                    setdataactive(data)
                })


    };

    const getdata = async () => {

        const sendData = {
            EmploymentId: Number(employmentId),
            UserId: Number(localStorage.getItem("userId")),
        }


        await fetch(process.env.REACT_APP_API_LINK + 'api/Main/Viewalldata', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {

                    if (data === "NO") {
                        setloading(false)
                        setDraft(true)

                    }
                    else {
                        setloading(false)
                        setDraft(false)
                        setemloymentId(data.employmentId)
                        getdata2()
                        Total(data.employmentId)
                        Total2(data.employmentId)
                        setuserData(data)
                    }

                })


    };

    const generate = async () => {
        if (formData.year > 0 && formData.month > 0) {
            setloading(false)
            setGloading(true)
            const sendData = {
                UserId: Number(localStorage.getItem("userId")),
                EmploymentRefId: Number(formData.EmploymentRefId),
                YearId: Number(formData.year),
                MonthId: Number(formData.month),
            }
            //console.log(sendData)

            await fetch(process.env.REACT_APP_API_LINK + 'api/Main/GenerateES6', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(sendData)

            })
                .then(response => response.json())
                .then(
                    data => {
                        if (data === "Error") {
                            Swal.fire({
                                title: ' This Month Report is Already Submitted',
                                icon: 'error',

                            })
                        } else {
                            setloading(false)
                            setGloading(false)
                            getdata()
                        }

                    })
        } else {
            Swal.fire({
                icon: "warning",
                title: "Month or Year Not Selected",
                text: "Please Select Month and Year",
                focusConfirm: false,
            }).then(() => {
                props.history.push("/Dashboard")
            })
        }

    };

    useEffect(() => {
        if (employmentId > 0) {
            Total(employmentId)
            Total2(employmentId)
            setchange(!Change)
        }
    }, [GTotal])

    useEffect(() => {

        setloading(true)
        getdata()
    }, [])

    const onFormSubmit = async () => {

        Swal.fire({
            title: 'Are You Sure you want to Submit  ?',
            icon: 'question',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Yes',
            confirmButtonColor: 'success',
            denyButtonText: `No`,
        }).then(async (result) => {

            if (result.isConfirmed) {
                const sendData = {

                    EmploymentId: employmentId,
                }

                //console.log(sendData)
                await fetch(process.env.REACT_APP_API_LINK + 'api/Main/Submitform', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(sendData)

                })
                    .then(response => response.json())
                    .then(
                        data => {
                            if (data === "Done") {
                                props.history.push("/Dashboard")
                            } else {
                                Swal.fire({
                                    title: 'Data Not Submitted',
                                    icon: 'error',

                                })
                            }

                        })


            } else if (result.isDenied) {
                getdata()
            }
        })



    };

    const onSaveDraftGoBack = async () => {

        Swal.fire({
            title: 'Data Saved Successfully',
            icon: 'success',

        })
        props.history.push("/Dashboard")
        getdata()

    };

    const onSaveDraft = async () => {

        Swal.fire({
            title: 'Data Saved Successfully',
            icon: 'success',

        })
        getdata2()
        getdata()


    };

    const inputRef = useRef(null);

    const handleClick = () => {
        // 👇️ open file input box on click of another element
        inputRef.current.click();
    };


    const categorizeData = (data) => {
        return data.map((item) => {
            const categorized = {
                SNo: item.SNo,
                OutstandingCurrentMonth: {},
                OutstandingPreviousMonth: {},
                Filled: {},
                Cancelled: {},
                Notified: {}
            };

            // Iterate through the data and categorize by key prefix
            Object.entries(item).forEach(([key, value]) => {
                if (key.startsWith('OutstandingCurrentMonth')) {
                    categorized.OutstandingCurrentMonth[key] = value;
                } else if (key.startsWith('OutstandingPreviousMonth')) {
                    categorized.OutstandingPreviousMonth[key] = value;
                } else if (key.startsWith('Filled')) {
                    categorized.Filled[key] = value;
                } else if (key.startsWith('Cancelled')) {
                    categorized.Cancelled[key] = value;
                } else if (key.startsWith('Notified')) {
                    categorized.Notified[key] = value;
                }
            });

            return categorized;
        });
    };


    //IMport Excel
    const readUploadFile = async (e) => {
        e.preventDefault();
        setexportloading(true);

        if (!e.target.files) return;

        const reader = new FileReader();

        reader.onload = async (e) => {
            try {
                const data = e.target.result;
                const workbook = xlsx.read(data, { type: "array" });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const json = xlsx.utils.sheet_to_json(worksheet);

                const jsonfial = categorizeData(json);

                const paramLookup = new Map(
                    dataactive.map((param) => [Number(param.sno), param.parametersId])
                );

                let errors = 0;
                let allErrorMessages = [];

                // Helper function to check errors
                const checkError = (total, value, fieldName) => {
                    if (total < value) {
                        return `<span style="color: red; font-weight: bold;">${fieldName}</span>`;
                    }
                    return null;
                };

                for (let i = 0; i < jsonfial.length; i++) {
                    const item = jsonfial[i];
                    let errorFields = [];

                    // Perform all field checks
                    [
                        { total: item.OutstandingPreviousMonth.OutstandingPreviousMonthTotal3, value: item.OutstandingPreviousMonth.OutstandingPreviousMonthObc7, name: "OutstandingPreviousMonthObc7" },
                        { total: item.OutstandingPreviousMonth.OutstandingPreviousMonthTotal3, value: item.OutstandingPreviousMonth.OutstandingPreviousMonthSc5, name: "OutstandingPreviousMonthSc5" },
                        { total: item.OutstandingPreviousMonth.OutstandingPreviousMonthTotal3, value: item.OutstandingPreviousMonth.OutstandingPreviousMonthWomen4, name: "OutstandingPreviousMonthWomen4" },
                        { total: item.OutstandingPreviousMonth.OutstandingPreviousMonthTotal3, value: item.OutstandingPreviousMonth.OutstandingPreviousMonthSt6, name: "OutstandingPreviousMonthSt6" },

                        { total: item.OutstandingCurrentMonth.OutstandingCurrentMonthTota23, value: item.OutstandingCurrentMonth.OutstandingCurrentMonthWomen24, name: "OutstandingCurrentMonthWomen24" },
                        { total: item.OutstandingCurrentMonth.OutstandingCurrentMonthTota23, value: item.OutstandingCurrentMonth.OutstandingCurrentMonthSc25, name: "OutstandingCurrentMonthSc25" },
                        { total: item.OutstandingCurrentMonth.OutstandingCurrentMonthTota23, value: item.OutstandingCurrentMonth.OutstandingCurrentMonthSt26, name: "OutstandingCurrentMonthSt26" },
                        { total: item.OutstandingCurrentMonth.OutstandingCurrentMonthTota23, value: item.OutstandingCurrentMonth.OutstandingCurrentMonthObc27, name: "OutstandingCurrentMonthObc27" },
                    ].forEach(({ total, value, name }) => {
                        const errorMsg = checkError(total, value, name);
                        if (errorMsg) errorFields.push(errorMsg);
                    });

                    if (errorFields.length > 0) {
                        errors++;
                        allErrorMessages.push(
                            `❌ Error at S.No <b>${item.SNo}</b>:<br>${errorFields.join("<br>")}`
                        );
                    }
                }

                // Show all errors at once
                if (errors > 0) {
                    let displayedErrors = allErrorMessages.slice(0, 1);
                    Swal.fire({
                        title: "❌ Errors Found",
                        html: `${displayedErrors.join("<br><br>")} <br><br> <b style="color: red;">Please correct them and reupload.</b>`,
                        icon: "error",
                        width: "600px",
                    });

                    setexportloading(false);
                    return;
                }

                // Prepare data for sending
                const senddata = json.map((item) => ({
                    ...item,
                    UserId: Number(localStorage.getItem("userId")),
                    ParametersID: paramLookup.get(item["SNo"]) || null,
                    EmploymentId: employmentId,
                }));
                /*console.log("SendData: ", senddata)*/

                // Send API requests one by one (sequentially)
                for (let i = 0; i < senddata.length; i++) {
                    try {
                        const response = await fetch(
                            process.env.REACT_APP_API_LINK + "api/Main/UpdateDetailsES6",
                            {
                                method: "POST",
                                headers: {
                                    Accept: "application/json",
                                    "Content-Type": "application/json",
                                },
                                body: JSON.stringify(senddata[i]),
                            }
                        );

                        if (!response.ok) throw new Error("Failed to update row " + senddata[i]["SNo"]);

                        /*console.log(`✅ Row ${senddata[i]["SNo"]} updated successfully`);*/
                    } catch (error) {
                        console.error("❌ Error updating row:", error);
                        Swal.fire({
                            title: "❌ Upload Error",
                            text: `Error updating row ${senddata[i]["SNo"]}. Skipping to the next row...`,
                            icon: "error",
                        });
                    }
                }

                Swal.fire({
                    title: "✅ Upload Complete",
                    text: "All rows have been processed successfully.",
                    icon: "success",
                });

                getdata();
            } catch (error) {
                console.error("Error reading file:", error);
                Swal.fire({
                    title: "❌ File Read Error",
                    text: "An error occurred while reading the file. Please check the format and try again.",
                    icon: "error",
                });
            } finally {
                setexportloading(false);
            }
        };

        reader.readAsArrayBuffer(e.target.files[0]);
    };


    const handleDownloadXlsx = () => {
        const link = document.createElement('a');

        // Set the download attribute with the file name
        link.download = 'ES6 format.xlsx';

        // Set the href to the path of the file in the public folder
        link.href = '/Excel/ES6.xlsx';

        // Trigger the download by simulating a click
        link.click();
    };

    return (
        <React.Fragment>
            <Head title="ES6-Edit" />
            {exportloading ? (
                <div className="loader-container">
                    <div className="spinner"></div>
                    < div className="message">Please wait while we upload the Excel Data and Do not Refresh the page ⌛ </div>

                </div>
            ) :
                <Content>
                    {loading ? <Spinner color="success" /> :
                        <Block>
                            <Button onClick={() => window.location.href = '/Dashboard'} color="dark"><em className="icon ni ni-back-alt"></em> BACK</Button>
                            <Card className="card-bordered card-stretch" style={{ padding: 20 }}>
                                {/*<NavbarDynamic/>*/}
                                <div style={{ border: "2px solid black", padding: 10 }}>
                                    <Row className="gy-4" >
                                        <Col md="3">
                                            <h3>
                                                Employment Return (ES6) {" "}
                                            </h3>
                                        </Col>
                                        <Col md="3">
                                            <input
                                                style={{ display: "none" }}
                                                type="file"
                                                name="upload"
                                                id="upload"
                                                onChange={readUploadFile}
                                                ref={inputRef}
                                            />

                                            {Draft ? null : (
                                                <Button style={{ margin: "1.5rem" }} color="success">
                                                    <Icon className="icon ni ni-arrow-up-circle"></Icon>
                                                    <b
                                                        style={{ fontSize: 18 }}
                                                        onClick={() => handleClick()}
                                                    >
                                                        {" "}
                                                        Import Data from Excel{" "}
                                                    </b>
                                                </Button>
                                            )}
                                        </Col>
                                        <Col md="3">
                                            {/* Button for custom .xlsx download */}
                                            <Button style={{ margin: '1.5rem' }} color="info" onClick={handleDownloadXlsx}>
                                                <Icon className="icon ni ni-download"></Icon>
                                                <b style={{ fontSize: 18 }}>Download Excel Format</b>
                                            </Button>
                                        </Col>
                                        <Col md="3">
                                            <DownloadTableExcel
                                                filename="ES6 Edit Report"
                                                sheet="users"
                                                currentTableRef={tableRef.current}
                                            >
                                                {Draft ? null : <Button style={{ float: "right", margin: '1.5rem' }} color="warning" ><Icon className="icon ni ni-download"></Icon><b style={{ fontSize: 18 }}>Export Excel</b></Button>}
                                            </DownloadTableExcel>{" "}
                                        </Col>
                                    </Row>
                                </div>

                                {Draft ? <Row className="gy-4">

                                    <Col md="6">
                                        <OptionCDisable onInputChange={onInputChange} namemain="year" mainid="year" />
                                    </Col>
                                    {Gloading === false ? <Col md="6">
                                        <Button color="success" onClick={() => generate()} >Generate</Button>
                                    </Col> : <Spinner color="success" />}
                                </Row> :
                                    <Card style={{ marginTop: 20, border: "2px solid black", padding: 10 }} className="card-bordered card-stretch">
                                        <Row className="gy-4">
                                            <Col md="6">
                                                <FormGroup>
                                                    <label className="form-label" htmlFor="Month">
                                                        Center: <label style={{ fontWeight: "normal" }}>  {userData.user !== undefined ? userData.user.state : "Not Specified"}</label>
                                                    </label>

                                                </FormGroup>
                                            </Col>
                                            <Col md="6">
                                                <FormGroup>
                                                    <label className="form-label" htmlFor="Month">
                                                        Name of Employment Exchange: <label style={{ fontWeight: "normal" }}>  {userData.user !== undefined ? userData.user.answer1 : "Not Specified"}</label>
                                                    </label>

                                                </FormGroup>
                                            </Col>
                                            <Col md="6">
                                                <FormGroup>
                                                    <label className="form-label" htmlFor="Month">
                                                        Month: <label style={{ fontWeight: "normal" }}> {month1[userData.monthId]}</label>
                                                    </label>

                                                </FormGroup>
                                            </Col>
                                            <Col md="6">
                                                <FormGroup>
                                                    <label className="form-label" htmlFor="Month">
                                                        ES 6: Return showing the work done by the Employment Exchanges: <label style={{ fontWeight: "normal" }}>  </label>
                                                    </label>

                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <div className="card-inner-group" style={{ border: '2px solid black', padding: 2 }}>

                                            <div style={{ height: window.innerHeight - 300, width: 'auto', overflow: 'scroll' }} className="table-responsive">
                                                <table className="table" style={{ borderCollapse: "separate", borderSpacing: 0 }}>
                                                    <thead style={{ position: '-webkit-sticky', position: "sticky", top: 0, backgroundColor: '#edecec' }}>
                                                        <tr >

                                                            <th rowSpan="3" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                                S. No.

                                                            </th>
                                                            <th rowSpan="3" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', minWidth: 100 }} >
                                                                Sectors
                                                            </th>
                                                            <th colSpan="5" rowSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                                No of outstanding vacancies at the end of previous  month

                                                            </th>
                                                            <th colSpan="15" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                                Number of Vacancies during the current month
                                                            </th>
                                                            <th colSpan="5" rowSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                                No of outstanding vacancies at the end of current  month
                                                            </th>


                                                        </tr>
                                                        <tr>

                                                            <td colSpan="5" style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }} > Notified </td>
                                                            <td colSpan="5" style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }} > Filled </td>
                                                            <td colSpan="5" style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }} > Cancelled </td>


                                                        </tr>
                                                        <tr>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >Total </td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >Women</td>

                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >SC </td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >ST </td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} > OBC</td>

                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >Total </td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >Women</td>

                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >SC </td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >ST </td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} > OBC</td>

                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >Total </td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >Women</td>

                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >SC </td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >ST </td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} > OBC</td>

                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >Total </td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >Women</td>

                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >SC </td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >ST </td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} > OBC</td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >Total </td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >Women</td>

                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >SC </td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >ST </td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} > OBC</td>

                                                        </tr>

                                                    </thead>

                                                    <tbody>

                                                        {dataactive.length > 0 ? dataactive.map((details, index) =>
                                                            details.parentId === 0 ? (
                                                                <tr key={details.sno || index} scope="row">
                                                                    <td>
                                                                        <b>{details.sno}</b>
                                                                    </td>
                                                                    <td>
                                                                        <b>{details.name}</b>
                                                                    </td>
                                                                </tr>
                                                            ) : details.parentId === -1 ? (
                                                                <tr key={details.sno || index} scope="row">
                                                                    <td>
                                                                        <b>{details.sno}</b>
                                                                    </td>
                                                                    <td>
                                                                        <b>{details.name}</b>
                                                                    </td>
                                                                    <td style={{ textAlign: 'center', padding: 10 }}>
                                                                        {Totall2.outstandingPreviousMonthTotal3}
                                                                    </td>
                                                                    <td style={{ textAlign: 'center', padding: 10 }}>
                                                                        {Totall2.outstandingPreviousMonthWomen4}
                                                                    </td>
                                                                    <td style={{ textAlign: 'center', padding: 10 }}>
                                                                        {Totall2.outstandingPreviousMonthSc5}
                                                                    </td>
                                                                    <td style={{ textAlign: 'center', padding: 10 }}>
                                                                        {Totall2.outstandingPreviousMonthSt6}
                                                                    </td>
                                                                    <td style={{ textAlign: 'center', padding: 10 }}>
                                                                        {Totall2.outstandingPreviousMonthObc7}
                                                                    </td>
                                                                    <td style={{ textAlign: 'center', padding: 10 }}>
                                                                        {Totall2.notifiedTotal8}
                                                                    </td>
                                                                    <td style={{ textAlign: 'center', padding: 10 }}>
                                                                        {Totall2.notifiedWomen9}
                                                                    </td>
                                                                    <td style={{ textAlign: 'center', padding: 10 }}>
                                                                        {Totall2.notifiedSc10}
                                                                    </td>
                                                                    <td style={{ textAlign: 'center', padding: 10 }}>
                                                                        {Totall2.notifieSt11}
                                                                    </td>
                                                                    <td style={{ textAlign: 'center', padding: 10 }}>
                                                                        {Totall2.notifiedObc12}
                                                                    </td>
                                                                    <td style={{ textAlign: 'center', padding: 10 }}>
                                                                        {Totall2.filledTotal13}
                                                                    </td>
                                                                    <td style={{ textAlign: 'center', padding: 10 }}>
                                                                        {Totall2.filledWomen14}
                                                                    </td>
                                                                    <td style={{ textAlign: 'center', padding: 10 }}>
                                                                        {Totall2.filledSc15}
                                                                    </td>
                                                                    <td style={{ textAlign: 'center', padding: 10 }}>
                                                                        {Totall2.filledSt16}
                                                                    </td>
                                                                    <td style={{ textAlign: 'center', padding: 10 }}>
                                                                        {Totall2.filledObc17}
                                                                    </td>
                                                                    <td style={{ textAlign: 'center', padding: 10 }}>
                                                                        {Totall2.cancelledTotal18}
                                                                    </td>
                                                                    <td style={{ textAlign: 'center', padding: 10 }}>
                                                                        {Totall2.cancelledWomen19}
                                                                    </td>
                                                                    <td style={{ textAlign: 'center', padding: 10 }}>
                                                                        {Totall2.cancelledSc20}
                                                                    </td>
                                                                    <td style={{ textAlign: 'center', padding: 10 }}>
                                                                        {Totall2.cancelledSt21}
                                                                    </td>
                                                                    <td style={{ textAlign: 'center', padding: 10 }}>
                                                                        {Totall2.cancelledObc22}
                                                                    </td>
                                                                    <td style={{ textAlign: 'center', padding: 10 }}>
                                                                        {Totall2.outstandingCurrentMonthTota23}
                                                                    </td>
                                                                    <td style={{ textAlign: 'center', padding: 10 }}>
                                                                        {Totall2.outstandingCurrentMonthWomen24}
                                                                    </td>
                                                                    <td style={{ textAlign: 'center', padding: 10 }}>
                                                                        {Totall2.outstandingCurrentMonthSc25}
                                                                    </td>
                                                                    <td style={{ textAlign: 'center', padding: 10 }}>
                                                                        {Totall2.outstandingCurrentMonthSt26}
                                                                    </td>
                                                                    <td style={{ textAlign: 'center', padding: 10 }}>
                                                                        {Totall2.outstandingCurrentMonthObc27}
                                                                    </td>
                                                                </tr>
                                                            ) : (
                                                                <ES6Update
                                                                    key={details.sno || index}
                                                                    Change={Change}
                                                                    setGTotal={setGTotal}
                                                                    GTotal={GTotal}
                                                                    sno={details.sno}
                                                                    edit={true}
                                                                    name={details.name}
                                                                    parametersId={details.parametersId}
                                                                    employmentId={employmentId}
                                                                    ES6Update={ES6Update}
                                                                />
                                                            )
                                                        ) : null}

                                                        <tr scope="row" >

                                                            <td>



                                                            </td>

                                                            <td>

                                                                <b>  Total</b>

                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.outstandingPreviousMonthTotal3}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.outstandingPreviousMonthWomen4}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.outstandingPreviousMonthSc5}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.outstandingPreviousMonthSt6}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.outstandingPreviousMonthObc7}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.notifiedTotal8}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.notifiedWomen9}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.notifiedSc10}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.notifieSt11}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.notifiedObc12}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.filledTotal13}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.filledWomen14}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.filledSc15}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.filledSt16}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.filledObc17}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.cancelledTotal18}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.cancelledWomen19}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.cancelledSc20}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.cancelledSt21}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.cancelledObc22}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.outstandingCurrentMonthTota23}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.outstandingCurrentMonthWomen24}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.outstandingCurrentMonthSc25}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.outstandingCurrentMonthSt26}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.outstandingCurrentMonthObc27}
                                                            </td>

                                                        </tr>

                                                    </tbody>
                                                </table>

                                            </div>

                                            <div style={{ visibility: 'hidden', height: 0, width: 0 }} className="table-responsive">
                                                <table className="table" ref={tableRef} style={{ borderCollapse: "separate", borderSpacing: 0 }}>
                                                    <thead style={{ position: '-webkit-sticky', position: "sticky", top: 0, backgroundColor: '#edecec' }}>
                                                        <tr >

                                                            <th rowSpan="3" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                                S. No.

                                                            </th>
                                                            <th rowSpan="3" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', minWidth: 100 }} >
                                                                Sectors
                                                            </th>
                                                            <th colSpan="5" rowSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                                No of outstanding vacancies at the end of previous  month

                                                            </th>
                                                            <th colSpan="15" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                                Number of Vacancies during the current month
                                                            </th>
                                                            <th colSpan="5" rowSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                                No of outstanding vacancies at the end of current  month
                                                            </th>


                                                        </tr>
                                                        <tr>

                                                            <td colSpan="5" style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }} > Notified </td>
                                                            <td colSpan="5" style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }} > Filled </td>
                                                            <td colSpan="5" style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }} > Cancelled </td>


                                                        </tr>
                                                        <tr>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >Total </td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >Women</td>

                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >SC </td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >ST </td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} > OBC</td>

                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >Total </td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >Women</td>

                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >SC </td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >ST </td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} > OBC</td>

                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >Total </td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >Women</td>

                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >SC </td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >ST </td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} > OBC</td>

                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >Total </td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >Women</td>

                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >SC </td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >ST </td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} > OBC</td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >Total </td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >Women</td>

                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >SC </td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >ST </td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} > OBC</td>

                                                        </tr>

                                                    </thead>

                                                    <tbody>

                                                        {dataactive.length > 0 ? dataactive.map((details, index) =>
                                                            details.parentId === 0 ?(
                                                                <tr key={index} scope="row" >
                                                                    <td >
                                                                        <b>  {details.sno}</b>-
                                                                    </td>
                                                                    <td >
                                                                        <b>  {details.name}</b>-
                                                                    </td>
                                                                </tr>
                                                            ) : details.parentId === -1 ? (
                                                                    <tr key={index} scope="row" >
                                                                        <td >
                                                                            <b>  {details.sno}</b>
                                                                        </td>
                                                                        <td >
                                                                            <b>  {details.name}</b>
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall2.outstandingPreviousMonthTotal3}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall2.outstandingPreviousMonthWomen4}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall2.outstandingPreviousMonthSc5}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall2.outstandingPreviousMonthSt6}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall2.outstandingPreviousMonthObc7}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall2.notifiedTotal8}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall2.notifiedWomen9}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall2.notifiedSc10}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall2.notifieSt11}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall2.notifiedObc12}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall2.filledTotal13}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall2.filledWomen14}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall2.filledSc15}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall2.filledSt16}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall2.filledObc17}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall2.cancelledTotal18}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall2.cancelledWomen19}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall2.cancelledSc20}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall2.cancelledSt21}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall2.cancelledObc22}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall2.outstandingCurrentMonthTota23}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall2.outstandingCurrentMonthWomen24}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall2.outstandingCurrentMonthSc25}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall2.outstandingCurrentMonthSt26}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall2.outstandingCurrentMonthObc27}
                                                                        </td>

                                                                    </tr>
                                                                ) : (
                                                                        <ES6Update
                                                                            key={index}
                                                                            Change={Change}
                                                                            setGTotal={setGTotal}
                                                                            GTotal={GTotal}
                                                                            sno={details.sno}
                                                                            edit={false}
                                                                            name={details.name}
                                                                            parametersId={details.parametersId}
                                                                            employmentId={employmentId}
                                                                            ES6Update={ES6Update}
                                                                        />
                                                                    )
                                                        ) : null}
                                                        <tr scope="row" >

                                                            <td>



                                                            </td>

                                                            <td>

                                                                <b>  Total</b>

                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.outstandingPreviousMonthTotal3}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.outstandingPreviousMonthWomen4}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.outstandingPreviousMonthSc5}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.outstandingPreviousMonthSt6}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.outstandingPreviousMonthObc7}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.notifiedTotal8}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.notifiedWomen9}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.notifiedSc10}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.notifieSt11}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.notifiedObc12}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.filledTotal13}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.filledWomen14}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.filledSc15}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.filledSt16}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.filledObc17}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.cancelledTotal18}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.cancelledWomen19}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.cancelledSc20}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.cancelledSt21}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.cancelledObc22}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.outstandingCurrentMonthTota23}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.outstandingCurrentMonthWomen24}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.outstandingCurrentMonthSc25}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.outstandingCurrentMonthSt26}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.outstandingCurrentMonthObc27}
                                                            </td>

                                                        </tr>

                                                    </tbody>
                                                </table>

                                            </div>

                                        </div>
                                        <div style={{ marginTop: 30, marginRight: -10 }}>
                                            <Button color='info' onClick={() => onSaveDraft()}>Save As Draft<em className="icon ni ni-unarchive"></em></Button>  <Button onClick={onFormSubmit} color='success'>Submit <em className="icon ni ni-file-check"></em></Button> <Button color='warning' onClick={() => onSaveDraftGoBack()}>Save As Draft And Back To Dashboard<em className="icon ni ni-signout"></em></Button>
                                        </div>
                                    </Card>}



                            </Card>

                        </Block>}

                </Content>
            }
        </React.Fragment>
    );
};

export default ES6Edit;
